import { UPDATE_INVOICE_BY_ID } from '../../endpoints';
import { Invoice } from '../../types/invoice';
import makeAuthenticatedRequest from '../base-api';

interface UpdateInvoiceResponse {
  success: boolean; 
  message?: string;
  invoice?: Invoice;
}


const updateInvoiceApi = async (invoiceId: string, payload: Invoice): Promise<UpdateInvoiceResponse> => {
  try {
    const response = await makeAuthenticatedRequest(UPDATE_INVOICE_BY_ID(invoiceId), {
      method: 'PUT',   
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result?.data;
  } catch (error) {
    console.error('Update invoice failed:', error);
    throw error;
  }
};

export { updateInvoiceApi, type UpdateInvoiceResponse };    
